import { MILE_VALUE } from './imperial-values.helpers';

export function metersToMiles(meters: number): number {
  return meters / MILE_VALUE;
}
